import { render, staticRenderFns } from "./industIot.vue?vue&type=template&id=309d806e&scoped=true"
import script from "./industIot.vue?vue&type=script&lang=js"
export * from "./industIot.vue?vue&type=script&lang=js"
import style0 from "./industIot.vue?vue&type=style&index=0&id=309d806e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d806e",
  null
  
)

export default component.exports